export * from './UIGameDiceProb.tsx';
